module.exports = __webpack_public_path__ + "de8f4237cf953bc84dd48151e44b4994.png";